<!-- @format -->

<div class="unit-wrapper">
	<div class="unit-navigation">
		<img
			src="../../assets/back-arrow-icon.svg"
			alt="back navigation" />
		<div class="prev-page">Branch</div>
		<img
			src="../../assets/forward-arrow-icon.svg"
			alt="back navigation" />
		<div class="forward-page">Edit a Branch</div>
	</div>
	<div class="card edit-unit">
		<h1 class="section-title">Edit Branch</h1>
		<p class="subtext">Fill out branch details using the form below.</p>
		<form
			(ngSubmit)="
				editUnitRequest.unitName.length === 0 ||
				unitNameUpdate === editUnitRequest.unitName
					? (showModal = false)
					: (showModal = true)
			"
			#form="ngForm"
			style="margin-top: 2rem">
			<app-custom-dropdown
				(setSelected)="setCompany($event)"
				[label]="'Account Holder Name'"
				[disabled]="true"
				[selectedItem]="selectedValues.company.companyName"
				[items]="companies" />

			<div class="dropdown-container">
				<app-custom-dropdown
					(setSelected)="setPlant($event)"
					style="flex: 1"
					[label]="'Client Name'"
					[disabled]="true"
					[selectedItem]="selectedValues.plant.plantName"
					[items]="plants" />
				<div class="unit-name">
					<label
						for="unit_name"
						class="custom-label required"
						>Branch Name</label
					>
					<input
						[(ngModel)]="editUnitRequest.unitName"
						type="text"
						class="custom-input"
						name="unit_name"
						id="unit_name" />
					<div
						*ngIf="!errorMessage.success"
						class="error">
						<img
							src="../../assets/alert.svg"
							alt="" />
						<p>
							{{ errorMessage.message }}
						</p>
					</div>
				</div>
			</div>

			<div class="btn-group">
				<button
					(click)="transferData()"
					class="btn-outline"
					routerLink="../..">
					Cancel
				</button>
				<button
					[ngClass]="
						editUnitRequest.unitName.length === 0 ||
						unitNameUpdate === editUnitRequest.unitName
							? 'btn-fill disabled'
							: 'btn-fill'
					"
					type="submit">
					Update Branch
				</button>
			</div>
		</form>
	</div>
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
<app-save-modal
	*ngIf="showModal"
	(closeModal)="closeModal()"
	(onSave)="editUnit()"></app-save-modal>
